module.exports = __webpack_public_path__ + "static/img/gzjt.8c141a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gzjt.png
// module id = fS8+
// module chunks = 1